import React, { Component } from 'react';
// import Apng from 'react-apng';
// import clientApi from '../../api/client';
// import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
// import {apiDefine} from '../../api/web'

import './style.less';

// import cloud from '../../static/images/homework-new/cloud.png'

class StepChange extends Component {
    constructor(props){
        super(props);
        this.state = {
            active: props.status === 'in'
        };
        this.timeOutArr = [];
    }
    cloudPlay = (cb) => {
        const { active } = this.state;
        this.timeOutArr.push(
            setTimeout(()=>{
                this.setState({active: !active});
            },100)
        );
        if(cb) cb();
    }
    // componentDidMount(){
    //     this.cloudStatuFun(this.props.status);
    // }
    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)))
    }
    // componentWillReceiveProps(nextProps){
    //     this.cloudStatuFun(nextProps.status);
    // }
    render(){
        const { active } = this.state;
        return(
            <div className="container homework_new step_change">
                <div className={`cloud ${active ? 'active' : ''} cloud1`}></div>
                <div className={`cloud ${active ? 'active' : ''} cloud2`}></div>
                <div className={`cloud ${active ? 'active' : ''} cloud3`}></div>
                <div className={`cloud ${active ? 'active' : ''} cloud4`}></div>
            </div>
        )
    }
}

export default StepChange;



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/StepChange.jsx